import React from 'react';
import { useNavigate } from 'react-router-dom';
import AppSidebar from '../../Components/layout/AppSidebar/AppSidebar';
import { ROLES, cabinetPath } from '../config';
import { DEMO_ROLE_KEY } from '../demoAccounts';

// Kabinet sidebar'i: mavjud AppSidebar, menyu — rol config'idan.
// Log out boshqa sidebar'lardagi bilan bir xil (token va rol o'chiriladi).
function CabinetSidebar({ role }) {
  const navigate = useNavigate();
  const def = ROLES[role];
  if (!def) return null;

  const handleLogout = () => {
    localStorage.removeItem('admin_token');
    localStorage.removeItem('role');
    localStorage.removeItem(DEMO_ROLE_KEY);
    navigate('/login');
    window.location.reload();
  };

  const groups = def.groups.map((group) => ({
    label: group.label,
    items: group.items.map((item) => ({ to: cabinetPath(role, item.key), label: item.label, icon: item.icon })),
  }));

  return <AppSidebar groups={groups} onLogout={handleLogout} />;
}

export default CabinetSidebar;
